<template>
  <div>
      <div v-if="data.inTPL == true">
          <h6>in TPL</h6>
      </div>
      <div v-else>
          <h6 style="margin-top: 2px;margin-bottom: 0;">{{$t("no")}}</h6>
          <button class="ag-button sm border-0 ag-button_primary ag-button_radius ml-2">{{$t("add")}}</button>
      </div>
  </div>
</template>

<script>
export default {
  name: "tableTrustedListStatus",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
};
</script>
